import Vue from 'vue';
import chequeOrder from './cash-payment-authorization/cash-payment-authorization.vue';

Vue.component('cash-payment-authorization', chequeOrder);
